module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_round-arrow-d886973f196c7bc6971ef8f6302cdbe9.svg";